export default __webpack_public_path__ + "static/media/aurore_la_defense.76f74f84.jpg";